import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { usePricesApi } from 'pages/hooks/usePricesApi';

import { Card } from 'components/cards/Card';
import { Page } from 'components/page/Page';

import { PairsGrid } from '../pairs/components/PairsGrid';

export default () => {
  const { search } = useLocation();
  const { getData } = usePricesApi();
  useEffect(() => {
    getData();
  }, [getData, search]);

  return (
    <Page title="Application">
      <Card>
        <PairsGrid />
      </Card>
      <Card>card</Card>
    </Page>
  );
};
